import React, { Component } from "react";
import InventoryCircuitPage from "../inventory-circuit.page"
class InventoryCircuitFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewPage: true,
            isUpdateInventory: true
        }
    }

    render(){
        const { viewPage, isUpdateInventory } = this.state;
        const { invoiceAuditID, invoiceID } = this.props.match.params;
        return (
            <>
                <InventoryCircuitPage viewDetailPage={viewPage} isUpdateInventory={isUpdateInventory} invoiceID={invoiceID} invoiceAuditID={invoiceAuditID} />
            </>
        )
    }
}

export default InventoryCircuitFilter